import { EventEmitter, SimpleChanges } from '@angular/core';

import { IIdentity, GridApi, GridSync } from '@grid/models';
import { SelectedSubproject } from '@shared/models';
import { EditableComponent } from './editable-component.model';

export interface RegistrationsComponent<T extends IIdentity>
  extends EditableComponent {
  ngOnChanges: (changes: SimpleChanges) => void;
  gridData: T[];
  predefinedChanges: GridSync<T>;
  selectedSubproject: SelectedSubproject;
  canEdit: boolean;
  dataChanged: EventEmitter<boolean>;
  gridRegistered: EventEmitter<GridApi<T>>;
  api: GridApi<T>;
  labeling?: { [key: string]: string };
}
